import React from 'react';
import { SimpleFlexbox, Anchor, Icon } from 'ctm-components';
import styles from './retrieve_quote_footer.css';

/**
 * Render the Retrieve Quote Footer component
 * @returns {Node} A component
 * @constructor
 */
const RetrieveQuoteFooter = () => {
    return (
        <SimpleFlexbox className={styles.container} variant="text_align_center" display="flex" column>
            <h3 className={styles.header}>Already completed a quote?</h3>
            {/* @todo add event handler */}
            <Anchor className={styles.underline}>
                Retrieve your car insurance quote
                <Icon variant="ctm_angle_right" margin="left" />
            </Anchor>
        </SimpleFlexbox>
    );
};

export { RetrieveQuoteFooter };
